class Regions extends Array {}

const regions_api_adapter = regions => {
    return regions;
};

const regions_api_list_adapter = regions => regions.map(regions_api_adapter);

const createRegionsList = (data = []) => {
    const regions = Regions.from(data, regions => createRegions(regions));
    return regions;
};

const regions_view_adapter = regions => {
    return regions;
};

const createRegions = ({
    id = null,
    geom = null,
    di_emp_n = null,
    di_emp_per = null,
    di_gva_me = null,
    di_gva_per = null,
    emp_n = null,
    emp_per = null,
    gva_me = null,
    gva_per = null,
    name = null,
    tii_emp_n = null,
    tii_emp_per = null,
    tii_gva_me = null,
    tii_gva_per = null,
    top5 = null,
    type = null,
} = {}) => {
    const publicApi = {
        id,
        geom,
        di_emp_n,
        di_emp_per,
        di_gva_me,
        di_gva_per,
        emp_n,
        emp_per,
        gva_me,
        gva_per,
        name,
        tii_emp_n,
        tii_emp_per,
        tii_gva_me,
        tii_gva_per,
        top5,
        type,
    };

    return Object.freeze(publicApi);
};

export {
    createRegions,
    createRegionsList,
    regions_api_adapter,
    regions_api_list_adapter,
    regions_view_adapter,
};
